import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { isSubmitting } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';

import { Scrollbars } from 'react-custom-scrollbars';

import Section, { SectionHeader, SectionTitle, SectionBody } from 'components/common/Section';
import Button from 'components/common/Button';
import IconClip from 'components/icons/IconClip';
import DocumentsViewDialog from 'components/common/DocumentsViewDialog';

import { createPatientDocument } from 'redux/modules/patientsDocuments';
import { addNotification } from 'redux/modules/notifications';


import hexToRgb from 'styles/hexToRgb';

import DocumentsItem from './DocumentsItem';
import DocumentsCreateDialog from './DocumentsCreateDialog';
import DocumentsFilterForm from './DocumentsFilterForm';
import DocumentsDragAndDropForm from './DocumentsDragAndDropForm';

const styles = theme => ({
  sectionBody: {
    paddingLeft: 8,
    paddingRight: 8,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  iconPlusOnSquare: {
    width: 33,
    height: 33,
    marginTop: 13,
    marginBottom: 15,
    color: theme.palette.primary.A400,
  },
  iconClip: {
    width: 9,
    height: 18,
    marginRight: 10,
  },
  button: {

  },
  typographyEmpty: {
    fontSize: 12,
    opacity: '0.5',
  },
  list: {
    padding: '0 16px',
  },
  dropzone: {
    position: 'relative',

    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 10,
      border: `1px solid rgba(${hexToRgb(theme.palette.common.white)}, 0)`,
      transition: theme.transitions.create(['border-color'], {
        duration: theme.transitions.duration.short,
      }),
    },
  },
  dropzoneAccept: {
    '&:before': {
      borderColor: theme.palette.primary[500],
    },
  },
  buttonContainer: {
    position: 'relative',
  },
  uploadFieldContainer: {
    padding: '16px 16px 0 16px',
  },
  documentsFilterForm: {
    padding: '16px 16px 0 16px',
  },
});

class Documents extends Component {
  constructor(props) {
    super(props);

    this.state = {
      createDialogOpen: false,
      viewDialogOpen: false,
      currentDocumentID: null,
      droppedDocuments: [],
    };

    this.onAttachButtonClick = this.onAttachButtonClick.bind(this);
    this.onCreateDialogClose = this.onCreateDialogClose.bind(this);
    this.onDocumentsItemClick = this.onDocumentsItemClick.bind(this);
    this.onViewDialogClose = this.onViewDialogClose.bind(this);
    this.onDragAndDropFormSubmitSuccess = this.onDragAndDropFormSubmitSuccess.bind(this);
  }

  onAttachButtonClick() {
    this.setState({ createDialogOpen: true });
  }

  onCreateDialogClose() {
    this.setState({
      createDialogOpen: false,
    });
  }

  onDocumentsItemClick(ID) {
    this.setState({
      viewDialogOpen: true,
      currentDocumentID: ID,
    });
  }

  onViewDialogClose() {
    this.setState({
      viewDialogOpen: false,
      currentDocumentID: null,
    });
  }

  onDragAndDropFormSubmitSuccess(values, dispatch) {
    this.setState({
      droppedDocuments: [values],
    });
    dispatch(addNotification({
      message: `"${values['File Name']}" was saved to chart Documents`,
      variant: 'success',
    }));
  }

  render() {
    const {
      patient,
      business,
      submitting,
      classes,
    } = this.props;
    const {
      createDialogOpen,
      viewDialogOpen,
      currentDocumentID,
      droppedDocuments,
    } = this.state;
    return (
      <Section>
        <SectionHeader>
          <SectionTitle>
            Documents
          </SectionTitle>
          {patient.Documents.length > 0 &&
            <div className={classes.buttonContainer}>
              <Button
                className={classes.button}
                variant="raised"
                disabled={!patient || submitting}
                onClick={this.onAttachButtonClick}
              >
                <IconClip className={classes.iconClip} />
                Attach
              </Button>
            </div>
          }
        </SectionHeader>
        <SectionBody
          className={classes.sectionBody}
          padding="none"
          empty={!patient || patient.Documents.length === 0}
        >
          {(!patient || patient.Documents.length === 0) ? (
            <Grid
              container
              direction="column"
              alignItems="center"
              justify="center"
              spacing={24}
            >
              <Grid item>
                <DocumentsDragAndDropForm
                  form="patientDocumentsDragAndDrop"
                  patient={patient}
                  onSubmitSuccess={this.onDragAndDropFormSubmitSuccess}
                />
              </Grid>
              <Grid item>
                <Button
                  className={classes.button}
                  variant="raised"
                  disabled={!patient || submitting}
                  onClick={this.onAttachButtonClick}
                >
                  <IconClip className={classes.iconClip} />
                  Attach
                </Button>
              </Grid>
            </Grid>
          ) : (
            <div>
              <DocumentsFilterForm
                form={`${patient['Record Number']}-documentsFilter`}
                className={classes.documentsFilterForm}
              />
              <div className={classes.uploadFieldContainer}>
                <DocumentsDragAndDropForm
                  form="patientDocumentsDragAndDrop"
                  patient={patient}
                  onSubmitSuccess={this.onDragAndDropFormSubmitSuccess}
                />
              </div>
{/*              <Scrollbars
                autoHeight
                autoHeightMin={0}
                autoHeightMax={500}
                thumbMinSize={30}
                universal
              >*/}
                <List className={classes.list}>
                  {patient.Documents.map(documentsItem => (
                    <DocumentsItem
                      key={documentsItem.ID}
                      {...{ 'Record Number': patient['Record Number'] }}
                      onClick={this.onDocumentsItemClick}
                      {...documentsItem}
                      business={business}
                      dropped={droppedDocuments.filter(item =>
                        item.ID === documentsItem.ID).length > 0}
                    />
                  ))}
                </List>
              {/*</Scrollbars>*/}
            </div>
          )}
          <DocumentsCreateDialog
            open={createDialogOpen}
            onClose={this.onCreateDialogClose}
            {... patient ? { 'Record Number': patient['Record Number'] } : {}}
          />
          {currentDocumentID &&
            <DocumentsViewDialog
              open={viewDialogOpen}
              onClose={this.onViewDialogClose}
              Documents={patient.Documents}
              initialDocumentID={currentDocumentID}
            />
          }
        </SectionBody>
      </Section>
    );
  }
}

Documents.propTypes = {
  patient: PropTypes.shape({
    'Record Number': PropTypes.number,
    Documents: PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number.isRequired,
    })).isRequired,
  }),
  actions: PropTypes.shape({
    createPatientDocument: PropTypes.func.isRequired,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  submitting: PropTypes.bool,
  classes: PropTypes.shape({
    button: PropTypes.string.isRequired,
    iconClip: PropTypes.string.isRequired,
    iconPlusOnSquare: PropTypes.string.isRequired,
    sectionBody: PropTypes.string.isRequired,
    typographyEmpty: PropTypes.string.isRequired,
    list: PropTypes.string.isRequired,
    dropzone: PropTypes.string.isRequired,
    dropzoneAccept: PropTypes.string.isRequired,
    buttonContainer: PropTypes.string.isRequired,
    uploadFieldContainer: PropTypes.string.isRequired,
  }).isRequired,
};

Documents.defaultProps = {
  patient: null,
  submitting: false,
  business: {},
};

const mapStateToProps = store => ({
  submitting: isSubmitting('patientDocumentsDragAndDrop')(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ createPatientDocument }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Documents));



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Documents/Documents.js